import React from "react";
import { Navigate } from "react-router-dom";
import StackTrace from "stacktrace-js";
import axios from "axios";

// 🌍 Make envType global
const hostname = window.location.hostname;
let envType = "PRODUCTION";
if (hostname === "localhost") envType = "LOCAL";
else if (hostname.includes("stage")) envType = "STAGE";

class ErrorBoundary extends React.Component {
  constructor() {
    super();
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const isTawkError =
      error?.message?.includes("i18next is not a function") ||
      error.toString().includes("i18next is not a function");

    if (isTawkError) {
      console.warn("Suppressed Tawk.to React ErrorBoundary error:", error);
      return;
    }

    this.setState({ hasError: true });

    StackTrace.fromError(error).then((stackframes) => {
      const stack = stackframes.map(f => f.toString()).join("\n");
      const form = new FormData();
      form.append("val", "in");
      form.append("type", "react-boundary");
      form.append("message", error.toString());
      form.append("stack", stack);
      form.append("url", window.location.href);
      form.append("user_agent", navigator.userAgent);

      sessionStorage.setItem("lastErrorInfo", JSON.stringify({
        message: error.toString(),
        stack
      }));

      if (envType !== "LOCAL") {
        axios.post("/pro/logs/errors.php", form).finally(() => {
          window.location.href = "/error-system";
        });
      }
    });
  }

  render() {
    if (this.state.hasError) {
      if (envType !== "LOCAL") {
        return <Navigate to="/error-system" replace />;
      } else {
        // Show detailed error in local environment
        const errorInfo = JSON.parse(sessionStorage.getItem("lastErrorInfo") || "{}");
  
        return (
          <div style={{ padding: "20px", fontFamily: "monospace", whiteSpace: "pre-wrap" }}>
            <h2 style={{ color: "red" }}>⚠️ React ErrorBoundary Caught an Error</h2>
            <p><strong>Message:</strong> {errorInfo.message || "No message available"}</p>
            <p><strong>Stack Trace:</strong></p>
            <pre>{errorInfo.stack || "No stack trace available"}</pre>
          </div>
        );
      }
    }
  
    return this.props.children;
  }
  
}

export default ErrorBoundary;
